/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The BookListPayloadModel model module.
 * @module model/BookListPayloadModel
 * @version v1.0.0
 */
class BookListPayloadModel {
    /**
     * Constructs a new <code>BookListPayloadModel</code>.
     * @alias module:model/BookListPayloadModel
     */
    constructor() { 
        
        BookListPayloadModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BookListPayloadModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BookListPayloadModel} obj Optional instance to populate.
     * @return {module:model/BookListPayloadModel} The populated <code>BookListPayloadModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BookListPayloadModel();

            if (data.hasOwnProperty('bookIdList')) {
                obj['bookIdList'] = ApiClient.convertToType(data['bookIdList'], ['String']);
            }
            if (data.hasOwnProperty('bookIsbnList')) {
                obj['bookIsbnList'] = ApiClient.convertToType(data['bookIsbnList'], ['String']);
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
        }
        return obj;
    }


}

/**
 * book id list
 * @member {Array.<String>} bookIdList
 */
BookListPayloadModel.prototype['bookIdList'] = undefined;

/**
 * book isbn list
 * @member {Array.<String>} bookIsbnList
 */
BookListPayloadModel.prototype['bookIsbnList'] = undefined;

/**
 * description
 * @member {String} description
 */
BookListPayloadModel.prototype['description'] = undefined;

/**
 * status
 * @member {module:model/BookListPayloadModel.StatusEnum} status
 */
BookListPayloadModel.prototype['status'] = undefined;

/**
 * title
 * @member {String} title
 */
BookListPayloadModel.prototype['title'] = undefined;





/**
 * Allowed values for the <code>status</code> property.
 * @enum {String}
 * @readonly
 */
BookListPayloadModel['StatusEnum'] = {

    /**
     * value: "Draft"
     * @const
     */
    "Draft": "Draft",

    /**
     * value: "Publish"
     * @const
     */
    "Publish": "Publish"
};



export default BookListPayloadModel;

